import React from 'react';
import ProductImageWrapper from './ImageContainer/ProductImageWrapper';
import Carousel from '../Carousel/Carousel';
import './LeftContent.scss';

const LeftContentNew = props => {
  const {
    productData,
    dataLocale: { RECENTLY_VIEWED_PRODUCTS },
  } = props;
  const { imageUrlsDetail, imageUrls } = productData.result;
  const recentViewProductList =
    __CLIENT__ && localStorage && localStorage.getItem('recentViewProducts')
      ? JSON.parse(localStorage.getItem('recentViewProducts'))
      : [];
  const changeCarouselSlide = (index, imageClick) => {
    // relatedItems
    if (imageClick) {
      // const { productData } = props;
      // const productDataResult = productData.result;
      // const { productUrl } = productDataResult.relatedItems[index];
      const { productUrl } = recentViewProductList[index];
      window.open(productUrl);
    }
  };

  const RecentProduct = props => {
    const { productDataResult, productData, changeCarouselSlide } = props;
    const RegExLargeProductImg = /(thumbnail\/628x301\/)[a-zA-Z0-9]{32}/gm;
    const largeProductImg =
      productData.result !== undefined ? productData.result.imageResolutions[1] : null;
    productDataResult.forEach((element, index) => {
      productDataResult[index].imageUrl = element.imageUrl.replace(
        RegExLargeProductImg,
        largeProductImg
      );
    });

    return (
      <div className="you-may-also-like">
        <div className="margin-t40 fw-bold fs16">{RECENTLY_VIEWED_PRODUCTS}</div>
        <Carousel
          brand="brand"
          carouselList={productDataResult}
          carouselStyle="custom-zoom-image"
          changeCarouselSlide={changeCarouselSlide}
          imageBorder={false}
          imageKey="imageUrl"
          price="price"
          slidesToShow={3}
        />
      </div>
    );
  };

  return (
    <div className="product-left-container">
      {/* display product images list with zoom feature */}
      <ProductImageWrapper
        imageUrls={imageUrls}
        imageUrlsDetail={imageUrlsDetail}
        productData={productData}
        {...props}
      />
      {recentViewProductList?.length > 0 && (
        <RecentProduct
          changeCarouselSlide={changeCarouselSlide}
          productData={productData}
          productDataResult={recentViewProductList}
        />
      )}
    </div>
  );
};

export default LeftContentNew;
